// Components
import Grid from "@mui/material/Grid";

type ExamCardContainerType = {
  backgroundColor?: string;
  children: React.ReactNode;
};

const ExamCardContainer = ({
  backgroundColor = "#202338",
  children,
}: ExamCardContainerType) => {
  return (
    <Grid
      container
      display="flex"
      flexDirection="column"
      gap="8px"
      width="100%"
      padding="8px"
      borderRadius="8px"
      sx={{
        backgroundColor,
      }}
    >
      {children}
    </Grid>
  );
};

export default ExamCardContainer;
